import axios from "axios";
import { message } from "antd";
import { API_END_POINT } from "../Config/urls";
import { buildAuthHeader } from "./authHeader";

const axiosInstance = axios.create({
  baseURL: API_END_POINT,
  timeout: 65000,
});

let isSessionExpiredToastShown = false;
let isUnAuthToastShown = false;

// API Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    if (!config.url.startsWith("/auth/user")) {
      // if (!config.url.startsWith("/login")) {
      config.headers.Authorization = buildAuthHeader();
    }
    return config;
  },
  (error) => {
    // Do something with request error here
    message.error("Error");
    Promise.reject(error);
  }
);

// API respone interceptor

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (axios.isCancel(error)) {
      // Suppress canceled requests
      console.log("Request canceled:", error.message);
      return Promise.resolve(); // Prevent further handling
    }
    // Remove token and redirect
    if (error.response) {
      const { status } = error.response;
      if (status === 401) {
        if (!isUnAuthToastShown) {
          try {
            message.destroy();
            if (error.response.data.Message) {
              message.error(error.response.data.Message);
            } else {
              message.error("Unauthorized: Please log in.");
            }
          } catch (error) {
            message.error("Unauthorized: Please log in.");
          }
          sessionStorage.clear();
          isUnAuthToastShown = true;
          setTimeout(() => {
            isUnAuthToastShown = false;
          }, 1000);
          if (!error.config.customHandle401) {
            setTimeout(() => {
              window.location.reload();
            }, 1500);
          }
        }
        return Promise.reject(error);
      } else if (status === 403 || status === 400) {
        if (isSessionExpiredToastShown) {
          return Promise.reject(error);
        }
        message.error("Session Expired. Please login again.");
        sessionStorage.clear();
        isSessionExpiredToastShown = true;
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else if (status === 404) {
        message.error("Not Found: The requested resource was not found.");
      } else if (status === 500) {
        try {
          console.log(error.response, "messagee");
          const detailMessage = error.response.data.detail;
          
          if (detailMessage) {
            message.error(detailMessage);
          } else {
            message.error("Internal Server Error: Something went wrong.");
          }
        } catch (error) {
          message.error("Internal Server Error: Something went wrong.");
        }
      } else if (status === 504) {
        // Handle HTTP 504 Gateway Timeout - show timeout message only for portfolio search
        const isPortfolioSearchRequest = 
          error.config?.url?.includes("Get_Filtered_Type_Search_Dealers") ||
          error.config?.url?.includes("Get_Radius_Type_Search_Dealers") ||
          error.config?.url?.includes("Get_Portfolio_Search_Options");
        
        if (isPortfolioSearchRequest) {
          message.warning("Search timed out due to large selection. Try selecting fewer brands.");
        } else {
          message.warning("Gateway Timeout: The server took too long to respond.");
        }
      } else if (status === 408) {
        message.error(error.response.data);
      } else {
        message.error("An error occurred. Please try again later.");
      }
    } else {
      // Handle CloudFront 504 errors that appear as Network Errors
      if (error.code === "ERR_NETWORK" && 
          error.message === "Network Error" && 
          error.config?.baseURL?.includes("cloudfront.net")) {
        // Check if it's a portfolio search request
        const isPortfolioSearchRequest = 
          error.config?.url?.includes("Get_Filtered_Type_Search_Dealers") ||
          error.config?.url?.includes("Get_Radius_Type_Search_Dealers") ||
          error.config?.url?.includes("Get_Portfolio_Search_Options");
        
        if (isPortfolioSearchRequest) {
          message.warning("Search timed out due to large selection. Try selecting fewer brands.");
        } else {
          message.warning("Network timeout: The server took too long to respond.");
        }
      } else {
        message.error("Network error. Please check your connection.");
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
